import { Job } from './types';
import { encodeJobId } from './jobId';

const mockJob = (
    uid: string,
    title: string,
    department: string,
    location: string,
    applyUrl: string,
    extra: Partial<Job> = {}
): Job => ({
    uid,
    title,
    department,
    location,
    applyUrl,
    encodedId: encodeJobId(uid),
    ...extra,
});

export const MOCK_COMEET_POSITIONS: Job[] = [
    mockJob(
        '4D.B6D',
        'Customer Support Operations Manager',
        'Customer Journey',
        'Tel Aviv',
        'https://www.comeet.com/jobs/fiverr/60.002/customer-support-operations-manager/4D.B6D'
    ),
    mockJob(
        'A1.C2D',
        'Product Designer',
        'Product',
        'Tel Aviv',
        'https://www.comeet.com/jobs/fiverr/60.002/product-designer/A1.C2D'
    ),
    mockJob(
        'B2.E3F',
        'Backend Developer',
        'Technology',
        'Kyiv',
        'https://www.comeet.com/jobs/fiverr/60.002/backend-developer/B2.E3F'
    ),
    mockJob(
        'C3.G4H',
        'Financial Analyst',
        'Finance',
        'New York',
        'https://www.comeet.com/jobs/fiverr/60.002/financial-analyst/C3.G4H'
    ),
    mockJob(
        'D4.I5J',
        'Software Engineer',
        'Technology',
        'Tel Aviv',
        'https://www.comeet.com/jobs/fiverr/60.002/software-engineer/D4.I5J'
    ),
    mockJob(
        'E5.K6L',
        'Growth Marketing Lead',
        'Marketing',
        'New York',
        'https://www.comeet.com/jobs/fiverr/60.002/growth-marketing-lead/E5.K6L'
    ),
    mockJob(
        'F6.M7N',
        'Data Analyst',
        'Product',
        'Kyiv',
        'https://www.comeet.com/jobs/fiverr/60.002/data-analyst/F6.M7N'
    ),
    mockJob(
        'G7.P8Q',
        'Frontend Engineer',
        'Technology',
        'Tel Aviv',
        'https://www.comeet.com/jobs/fiverr/60.002/frontend-engineer/G7.P8Q'
    ),
    mockJob(
        'H8.R9S',
        'UX Researcher',
        'Product',
        'New York',
        'https://www.comeet.com/jobs/fiverr/60.002/ux-researcher/H8.R9S'
    ),
    mockJob(
        'I9.T0U',
        'DevOps Engineer',
        'Technology',
        'Kyiv',
        'https://www.comeet.com/jobs/fiverr/60.002/devops-engineer/I9.T0U'
    ),
    mockJob(
        'J0.V1W',
        'Enterprise Sales Manager',
        'Sales',
        'New York',
        'https://www.comeet.com/jobs/fiverr/60.002/enterprise-sales-manager/J0.V1W'
    ),
    mockJob(
        'K1.X2Y',
        'Content Marketing Manager',
        'Marketing',
        'Tel Aviv',
        'https://www.comeet.com/jobs/fiverr/60.002/content-marketing-manager/K1.X2Y'
    ),
    mockJob(
        'L2.Z3A',
        'Data Scientist',
        'Technology',
        'New York',
        'https://www.comeet.com/jobs/fiverr/60.002/data-scientist/L2.Z3A'
    ),
    mockJob(
        'M3.B4C',
        'Account Manager',
        'Customer Journey',
        'Tel Aviv',
        'https://www.comeet.com/jobs/fiverr/60.002/account-manager/M3.B4C'
    ),
    mockJob(
        'N4.D5E',
        'Full Stack Developer',
        'Technology',
        'Kyiv',
        'https://www.comeet.com/jobs/fiverr/60.002/full-stack-developer/N4.D5E'
    ),
];

export const MOCK_JOB_DETAILED: Job = mockJob(
    'F6.M7N',
    'Senior Paid Acquisition Specialist, Search',
    'Marketing',
    'Tel Aviv',
    'https://www.comeet.com/jobs/fiverr/60.002/data-analyst/F6.M7N',
    {
        workplaceType: 'On-site',
        details: [
            {
                name: 'Description',
                order: 1,
                value: '<p>You’ll be expected to leverage AI tools and automation to enhance performance, increase efficiency, and uncover smarter ways to manage and analyze campaign data. We’re looking for someone who is AI-native and tech-savvy, able to integrate new tools and automation into daily work.</p>',
            },
            {
                name: 'About the role',
                order: 2,
                value:
                    '<ul>\n' +
                    '  <li>Monitor and optimize large-scale paid search campaigns across multiple channels (primarily Google Search), ensuring alignment with business objectives.</li>\n' +
                    '  <li>Leverage AI tools and emerging technologies to enhance workflows, improve operational efficiency, and strengthen campaign analysis.</li>\n' +
                    '  <li>Continuously explore and implement AI-driven methods to improve campaign performance and team productivity.</li>\n' +
                    '  <li>Stay up to date on the latest trends in paid search and digital marketing, continuously integrating new tactics to maintain a competitive edge.</li>\n' +
                    '  <li>Use analytical tools to evaluate campaign performance and deliver actionable insights to stakeholders, helping the team make informed decisions and achieve its goals.</li>\n' +
                    '  <li>Develop and manage monthly budget plans to optimize ROI.</li>\n' +
                    '</ul>',
            },
            {
                name: 'Core skills',
                order: 3,
                value:
                    '<ul>\n' +
                    '  <li>3+ years of hands-on experience in paid search or performance marketing, with a strong track record in data-driven campaign execution and optimization.</li>\n' +
                    '  <li>High level of AI fluency, including the use of automation and AI tools to streamline workflows, optimize campaign execution, and improve analytical processes.</li>\n' +
                    '  <li>Proven ability to manage and scale campaigns in Google Ads with clear performance ownership.</li>\n' +
                    '</ul>',
            },
            {
                name: 'Equal opportunities',
                order: 4,
                value: '<p>At Fiverr, we prioritize diversity. We celebrate difference and embed it into every aspect of our workplace and product, as well as our community. Fiverr is proud and committed to providing equal opportunity employment to all individuals regardless of race, color, religion, sex, sexual orientation, citizenship, national origin, disability, Veteran status, or any other characteristic protected by law. In addition, Fiverr will provide accommodation to individuals with disabilities or a special need. We believe great talent comes from diverse backgrounds and experiences. If you’re excited about this role but don’t meet every requirement, we still encourage you to apply.</p>',
            },
        ],
    }
);
